import React, { useState, useEffect } from 'react';
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";
import styles from './PatientList.module.css';
import PatientName from './PatientName';

function PatientList(props) {
    const [visibleFirst, setVisibleFirst] = useState(true);
    const [patientInfo, setPatientInfo] = useState([]); // [{}]) 대신 빈 배열([])로 초기화
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // 검색어 변경 시 페이지를 1로 리셋 (사용자 경험 개선)
    useEffect(() => {
        setCurrentPage(1);
    }, [props.search]);

    useEffect(() => {
        // 예전에는 여기서 SQL 조각을 만들어 보냈고 서버가 그것을 WHERE 에 그대로 붙였다.
        // 이제 검색어만 보내고 서버가 파라미터로 바인딩한다.
        const search = props.search ? props.search.trim() : '';

        const reqOption = {
            method: "post",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                search,
            })
        };

        fetch("/api/getPatientInfoList", reqOption)
            .then((response) => response.json())
            .then(data => {
                // 데이터가 없을 경우를 대비해 기본값 처리
                setPatientInfo(Array.isArray(data) ? data : []);
            })
            .catch(err => console.error("데이터 로드 실패:", err));
    }, [props.search]);

    // 전체 페이지 수 및 페이지 번호 배열 계산
    const totalItems = patientInfo?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    // 현재 페이지에 표시할 데이터 슬라이싱
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = patientInfo.slice(indexOfFirstItem, indexOfLastItem);

    // 환자 수 표시 로직 (num)
    const numDisplay = totalItems > 0 ? `(${totalItems})` : "";

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className={styles.title}>
            <div onClick={() => setVisibleFirst(!visibleFirst)} className={styles.PatientCode}>
                <span>
                    {!visibleFirst && <img className={styles.plusImg} src={sideTriangleIcon} alt="Expand" />}
                    {visibleFirst && <img className={styles.minusImg} src={downTriangleIcon} alt="Collapse" />}
                </span>
                <span className={styles.PatientListFirstTitle}>Patient Code</span>
                <span className={styles.PatientListNum}>{numDisplay}</span>
            </div>

            {visibleFirst && (
                <div className={styles.contentContainer}>
                    <div className={styles.cancerNamesContainer}>
                        {currentItems.length > 0 ? (
                            currentItems.map((data, index) => (
                                <PatientName name={data?.PatientCode} key={data?.PatientCode || index} />
                            ))
                        ) : (
                            <div style={{ padding: '10px', color: '#999' }}>데이터가 없습니다.</div>
                        )}
                    </div>

                    {totalPages > 0 && (
                        <div className={styles.paginationContainer}>
                            {pageNumbers.map(number => (
                                <span
                                    key={number}
                                    className={currentPage === number ? styles.activePage : styles.pageNumber}
                                    onClick={() => handlePageClick(number)}
                                >
                                    {number}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default PatientList;